import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { OrdersCoServices } from '../../services';
import { Globals } from '../../../../globals';
import { PrintServices } from '../../../services/printServices';
import { OrdersSelectPage } from '../../orders-select/orders-select';
import { TranslateService } from '@ngx-translate/core';
import { TPVServices } from '../../../tpv/services';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-table-list',
  templateUrl: 'orders-table-list.html',
})
export class OrdersTableListPage {
  orders: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    private printServices: PrintServices,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public tpvServices: TPVServices) {
    this.ordersCoServices.getOrders(this.globals.restaurant_uid, this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);
  }

  printSectionOrder(order, section) {
    this.globals.GAtrackView('Orders', 'Orders - Order - Print', this.globals.restaurant.email, 'View', 'Print order', 'Orders', '');
    if (this.globals.restaurant.printer_type == 'native') {
      this.ordersCoServices.kitchen_filter = 'orders';
      this.globals.print_content = document.getElementById('print_order');

      this.ordersCoServices.orders_print = 'change';
      this.ordersCoServices.print_order_part = section;
      this.ordersCoServices.print_order = order;
      //interval para imprimir correctamente
      var interval = setInterval(() => {
        this.printServices.printNow('print_order');
        clearInterval(interval);
      }, 1000);
    } else {
      this.printServices.prepareOrderKitchen('indv', section, order, this.globals.restaurant.printer_type, 'orders');
    }
  }

  openSelect() {
    this.ordersCoServices.update_state = false;
    this.navCtrl.push(OrdersSelectPage);
  }

  async onGoingKitchen(order, index) {
    if (this.globals.checkLimitsByLicense('tpv', 'marchar_cocina')) {
      //set ongoing true
      order.sections[index].ongoing = true;
      //update firestore
      this.ordersCoServices.afs.collection('orders').doc(order.UID).update({
        sections: order.sections,
        updated_at: new Date(),
      }).then(doc => {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-marchando-cocina'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  deleteTableList(index) {
    this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].ticket.list.splice(index, 1);
    this.ordersCoServices.afs.collection('tables').doc(this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID).update({
      'ticket.list': this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].ticket.list,
      'ticket.updated_at': new Date()
    });
  }

  async deleteTip() {
    //tip
    this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].ticket.tip = 0;
    var uid = this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID;
    //update tables
    this.ordersCoServices.afs.collection('tables').doc(uid).update({
      'ticket.tip': this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].ticket.tip,
      'ticket.updated_at': new Date()
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-table/orders-table-list/orders-table-list.ts